<template>
  <div class="calico-loader-page">
    <CalicoLoader />
  </div>
</template>

<script>
import CalicoLoader from "@/components/calico/loader/index.vue"
export default {
  name: 'LoaderPage',
  components: {
    CalicoLoader,
  },
};
</script>

<style lang="scss">
  .calico-loader-page {
    @include inline-space($space-none);
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40vw;
  }
</style>
